"use client";

import { c as _c } from "react/compiler-runtime";
import type { IconButtonProps, SpanProps } from "@chakra-ui/react";
import { ClientOnly, IconButton, Skeleton, Span } from "@chakra-ui/react";
import { ThemeProvider, useTheme } from "next-themes";
import type { ThemeProviderProps } from "next-themes";
import * as React from "react";
import { LuMoon, LuSun } from "react-icons/lu";
export interface ColorModeProviderProps extends ThemeProviderProps {}
export function ColorModeProvider(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ThemeProvider attribute="class" disableTransitionOnChange={true} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export type ColorMode = "light" | "dark";
export interface UseColorModeReturn {
  colorMode: ColorMode;
  setColorMode: (colorMode: ColorMode) => void;
  toggleColorMode: () => void;
}
export function useColorMode() {
  const $ = _c(7);
  const {
    resolvedTheme,
    setTheme,
    forcedTheme
  } = useTheme();
  const colorMode = forcedTheme || resolvedTheme;
  let t0;
  if ($[0] !== resolvedTheme || $[1] !== setTheme) {
    t0 = () => {
      console.log("and what");
      setTheme(resolvedTheme === "dark" ? "light" : "dark");
    };
    $[0] = resolvedTheme;
    $[1] = setTheme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const toggleColorMode = t0;
  const t1 = colorMode as ColorMode;
  let t2;
  if ($[3] !== setTheme || $[4] !== t1 || $[5] !== toggleColorMode) {
    t2 = {
      colorMode: t1,
      setColorMode: setTheme,
      toggleColorMode
    };
    $[3] = setTheme;
    $[4] = t1;
    $[5] = toggleColorMode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function useColorModeValue(light, dark) {
  const {
    colorMode
  } = useColorMode();
  return colorMode === "dark" ? dark : light;
}
export function ColorModeIcon() {
  const $ = _c(2);
  const {
    colorMode
  } = useColorMode();
  let t0;
  if ($[0] !== colorMode) {
    t0 = colorMode === "dark" ? <LuMoon /> : <LuSun />;
    $[0] = colorMode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
interface ColorModeButtonProps extends Omit<IconButtonProps, "aria-label"> {}
export const ColorModeButton = React.forwardRef<HTMLButtonElement, ColorModeButtonProps>(function ColorModeButton(props, ref) {
  const $ = _c(7);
  const {
    toggleColorMode
  } = useColorMode();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton boxSize="8" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      _icon: {
        width: "5",
        height: "5"
      }
    };
    t2 = <ColorModeIcon />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props || $[4] !== ref || $[5] !== toggleColorMode) {
    t3 = <ClientOnly fallback={t0}><IconButton onClick={toggleColorMode} variant="ghost" aria-label="Toggle color mode" size="sm" ref={ref} {...props} css={t1}>{t2}</IconButton></ClientOnly>;
    $[3] = props;
    $[4] = ref;
    $[5] = toggleColorMode;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
});
export const LightMode = React.forwardRef<HTMLSpanElement, SpanProps>(function LightMode(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Span {...props} color="fg" display="contents" className="chakra-theme light" colorPalette="gray" colorScheme="light" ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const DarkMode = React.forwardRef<HTMLSpanElement, SpanProps>(function DarkMode(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Span {...props} color="fg" display="contents" className="chakra-theme dark" colorPalette="gray" colorScheme="dark" ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});